import { render, staticRenderFns } from "./virtualRecharge.vue?vue&type=template&id=47f99ded&scoped=true&"
import script from "./virtualRecharge.vue?vue&type=script&lang=js&"
export * from "./virtualRecharge.vue?vue&type=script&lang=js&"
import style0 from "./virtualRecharge.vue?vue&type=style&index=0&id=47f99ded&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f99ded",
  null
  
)

export default component.exports